// hooks/projectCode/reducer.js
export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_PROJECT_CODES: 'SET_PROJECT_CODES',
    SET_SELECTED_PROJECT_CODE: 'SET_SELECTED_PROJECT_CODE',
    ADD_PROJECT_CODE: 'ADD_PROJECT_CODE',
    UPDATE_PROJECT_CODE: 'UPDATE_PROJECT_CODE',
    DELETE_PROJECT_CODE: 'DELETE_PROJECT_CODE',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE'
};

export const initialState = {
    projectCodes: [],
    selectedProjectCode: null,
    loading: false,
    error: null,
    filter: {
        code: null,
        name: null,
        status: null,
        type: null,
        department: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'code',
        direction: 'asc'
    },
    lastUpdated: null
};

export const projectCodeReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_PROJECT_CODES:
            return {
                ...state,
                projectCodes: action.payload.content || action.payload,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_PROJECT_CODE:
            return {
                ...state,
                selectedProjectCode: action.payload,
                loading: false
            };

        case ACTIONS.ADD_PROJECT_CODE:
            return {
                ...state,
                projectCodes: [action.payload, ...state.projectCodes],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_PROJECT_CODE:
            return {
                ...state,
                projectCodes: state.projectCodes.map((code) => (code.id === action.payload.id ? action.payload.data : code)),
                selectedProjectCode: state.selectedProjectCode?.id === action.payload.id ? action.payload.data : state.selectedProjectCode,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_PROJECT_CODE:
            return {
                ...state,
                projectCodes: state.projectCodes.filter((code) => code.id !== action.payload),
                selectedProjectCode: state.selectedProjectCode?.id === action.payload ? null : state.selectedProjectCode,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
